<script setup lang="ts">
interface TinderItem {
  id?: number;
  text?: string;
  description?: string;
  image?: string;
}

defineProps<{
  item: TinderItem;
}>();
</script>

<template>
  <div class="tinder-card" :style="{ backgroundImage: `url(${item?.image})` }">
    <div v-if="item.text || item.description" class="card-content">
      <!-- <h2 v-if="item.text">{{ item.text }}</h2>
      <p v-if="item.description">{{ item.description }}</p> -->
    </div>
  </div>
</template>

<style scoped>
.tinder-card {
  width: 100%;
  height: 508px;
  background-size: cover;
  background-position: center;
  border-radius: 34px;
  position: relative;
  overflow: hidden;
}

@media (min-width: 768px) and (max-width: 1023px) {
  .tinder-card {
    height: 529px;
    border-radius: 34px;
  }
}

@media (min-width: 1024px) and (max-width: 1439px) {
  .tinder-card {
    height: 565px;
    border-radius: 34px;
  }
}

@media (min-width: 1440px) and (max-width: 1919px) {
  .tinder-card {
    height: 565px;
    border-radius: 34px;
  }
}

@media (min-width: 1920px) {
  .tinder-card {
    height: 565px;
    border-radius: 34px;
  }
}

.card-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  color: white;
}

.card-content h2 {
  margin: 0 0 10px;
  font-size: 24px;
}

.card-content p {
  margin: 0;
  font-size: 16px;
}
</style>
